import React from 'react';
import { Card, Typography } from 'seagull';
import styles from "./IntegrationCard.module.scss";
export default function IntegrationCard(props) {
  const {
    'data-testid': testid,
    icon,
    title,
    subTitle,
    mainAction
  } = props;
  return /*#__PURE__*/React.createElement(Card, {
    "data-testid": testid,
    className: styles.card
  }, icon, /*#__PURE__*/React.createElement("div", {
    className: styles.textContainer
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h6",
    weight: "normal"
  }, title), /*#__PURE__*/React.createElement(Typography, {
    "data-testid": "".concat(testid, "-sub-title")
  }, subTitle)), /*#__PURE__*/React.createElement("div", {
    className: styles.actionButtonsWrapper
  }, mainAction));
}